import { call, put, delay } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import { createLogger } from 'helpers/logger';
import {
  setError,
  stopLoading,
  setMessage,
  setVerificationTimeOut,
  setVerificationEmail,
  setStep
} from 'reduxConfig/auth.creators';

const log = createLogger('[auth-saga]');

export function* authSendEmailVerification({ email }) {
  // Set a message if resending email to avoid
  // setting loading on the verify email button
  yield put(setMessage('auth_verify_sending'));
  try {
    yield call(window.FIREBASE.sendEmailVerification);
    yield put(setVerificationEmail(email));
    yield put(setMessage(null));
    yield put(setStep(STEPS.verifyEmail));
    for (let i = 59; i > 0; i--) {
      yield put(setVerificationTimeOut(i));
      yield delay(1000);
    }
  } catch (error) {
    log.info('Send email verification error:', error); // eslint-disable-line
    yield put(setError(ERRORS.sendEmailVerification));
  } finally {
    yield put(setMessage());
    yield put(setVerificationTimeOut(60));
    yield put(stopLoading());
  }
}
